import React, { useState, useEffect } from 'react';
import _split from 'lodash/split';
import _get from 'lodash/get';

// Components
import TextField from '@material-ui/core/TextField';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

const styles = defineStyles(theme => {
  return {
    row: {
      marginBottom: theme.spacing(2),
      paddingTop: 0,
    },
    inputLabel: {
      '&$cssFocused': {
        color: theme.palette.secondary.main,
      },
    },

    cssOutlinedInput: {
      '&$cssFocused': {
        color: theme.palette.secondary.main,
      },
    },
    cssFocused: {},

    multilineTextField: {
      marginLeft: -1,
      '& label': {
        padding: theme.spacing(0.5),
      },
      '& textarea': {
        padding: theme.spacing(0.25),
        marginTop: theme.spacing(-0.25),
      },
    },
    characterCount: {
      height: 18,
      display: 'flex',
      justifyContent: 'flex-end',
    },
  };
});

interface Props {
  onChange: (newAttribute: any) => void;
  classes: Classes<typeof styles>;
  attribute?: any;
}

const maxLength = 200;

function AttributeInputForm(props: Props) {
  const { classes, onChange, attribute } = props;
  const attributeDisplayName = _get(attribute, 'displayName', '');
  const attributeDescription = _get(attribute, 'display.description', '');

  return (
    <>
      <div className={classes.row}>
        <TextField
          label="Attribute Name"
          error={!attributeDisplayName}
          value={attributeDisplayName}
          helperText={'This field is required.'}
          onChange={e => onChange({ displayName: e.target.value })}
          InputLabelProps={{
            classes: {
              root: classes.inputLabel,
              focused: classes.cssFocused,
            },
          }}
          fullWidth
          inputProps={{
            maxLength: 40,
            'aria-label': attributeDisplayName,
          }}
        />
      </div>
      <div className={classes.row}>
        <TextField
          label="Attribute Description"
          value={attributeDescription}
          onChange={e => onChange({ display: { description: e.target.value } })}
          className={classes.multilineTextField}
          multiline
          rows="4"
          fullWidth
          InputLabelProps={{
            classes: {
              root: classes.inputLabel,
              focused: classes.cssFocused,
            },
          }}
          inputProps={{
            placeholder: `If you'd like to explain this attribute in greater detail to your users, add a description here!`,
            maxLength,
            'aria-label': 'description',
          }}
        />
        {attributeDescription.length > 100 && (
          <div className={classes.characterCount}>
            {attributeDescription.length}/{maxLength}
          </div>
        )}
      </div>
    </>
  );
}

export default withStyles(styles)(AttributeInputForm);
